import { Component, OnInit, ViewChild } from '@angular/core';
import { EpToastService, IEpTreeViewModel, IEpComponentEventArg, IEpComponentModel } from '@epicor/kinetic';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { FieldAgentClient, SmartView } from 'ep-bt-field-agent-proxy';
import { EpbtFaDynamicViewModel } from '../../models/epbt-fa-dynamic-view-model';
import { EpbtFaSmartviewsService } from '../../services/epbt-fa-smartviews.service';
import { Router, NavigationExtras } from '@angular/router';
import { subscribeOn } from 'rxjs/operators';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-smartviews',
  templateUrl: './epbt-fa-smartviews.component.html',
  styleUrls: ['./epbt-fa-smartviews.component.scss']
})
export class EpbtFaSmartviewsComponent implements OnInit {

  webTrackUser: any;
  epTreeView: IEpTreeViewModel;
  folderdata: any;
  SubFolders: SmartView[] = [];
  FirstFolders: any;
  public treeNodes: EpbtFaDynamicViewModel[] = [];

  constructor(private fieldAgentService: EpbtFieldAgentService, private client: FieldAgentClient,
    private router: Router, private SmartviewsService: EpbtFaSmartviewsService) { }


  ngOnInit() {
    this.fieldAgentService.getWebTrackUser((webTrackUser: any) => {
      this.webTrackUser = webTrackUser;
      // this.LoadSmartViews();
      // this.getTreeModel();
    });
  }



  // getTreeModel() {
  //   this.epTreeView = {
  //     nodes: this.treeNodes
  //   };
  // }

  // LoadSmartViews() {
  //   var folderNames = [];
  //   console.log("smart api start")
  //   this.client.getSmartViewsForUser(this.webTrackUser).subscribe(res => {
  //     this.folderdata = res;

  //     if (this.treeNodes.length != 0) {
  //       var nodes = this.prepareDataForTree(res);
  //       //this.addNode(nodes);
  //     }
  //     else {
  //       this.treeNodes = this.prepareDataForTree(res);;
  //       this.epTreeView.nodes = this.treeNodes;
  //     }
  //   });

  // }


  // prepareDataForTree(folders: any[]): any {
  //   var nodes: EpbtFaDynamicViewModel[] = [];
  //   var SubFolders: any;
  //   var MainFolder: any;
  //   var parentFolder: any;
  //   var subFolder: any;
  //   var isFolderExist: boolean = false;
  //   var menus: any[] = [];
  //   menus.push({
  //     id: 'SmartViews',
  //     parentId: '',
  //     link: '',
  //     caption: 'Smart Views',
  //     icon: 'mdi mdi-package mdi-18px'
  //   });

  //   if (folders && folders.length > 0) {
  //     folders.forEach(item => {
  //       var folderNames = item.groupName.split('\\');
  //       if (folderNames && folderNames.length > 1) {
  //         parentFolder = folderNames[folderNames.length - 2];
  //         subFolder = folderNames[folderNames.length - 1];
  //       }
  //       else {
  //         parentFolder = "SmartViews";
  //         subFolder = folderNames[folderNames.length - 1];
  //       }

  //       isFolderExist = menus.findIndex(x => x.id == subFolder) > 0 ? true : false;

  //       if (item.name) {
  //         if (!isFolderExist) {
  //           menus.push({
  //             id: subFolder,
  //             parentId: parentFolder,
  //             link: '',
  //             caption: subFolder,
  //             icon: 'mdi mdi-package mdi-18px'
  //           });
  //         }

  //         menus.push({
  //           id: item.name,
  //           parentId: subFolder,
  //           link: '',
  //           caption: item.name,
  //           icon: 'mdi mdi-user mdi-18px'
  //         });

  //       }
  //       else {
  //         menus.push({
  //           id: subFolder,
  //           parentId: parentFolder,
  //           link: '',
  //           caption: subFolder,
  //           icon: 'mdi mdi-package mdi-18px'
  //         });
  //       }


  //       // if (folderNames && folderNames.length > 1) {
  //       //   menus.push({
  //       //     id: subFolder,
  //       //     parentId: parentFolder,
  //       //     link: '',
  //       //     caption: subFolder,
  //       //     icon: 'mdi mdi-package mdi-18px'
  //       //   });
  //       // }
  //       // else {
  //       //   menus.push({
  //       //     id: subFolder,
  //       //     parentId: parentFolder,
  //       //     link: '',
  //       //     caption: subFolder,
  //       //     icon: 'mdi mdi-package mdi-18px'
  //       //   });
  //       // }
  //     });
  //   }


  //   // if (folders && folders.length > 0) {
  //   //   folders.forEach(item => {
  //   //     var folderNames = item.groupName.split('\\');
  //   //     // console.log(folderNames, "folders separated");
  //   //     if (folderNames.length > 1) {
  //   //       MainFolder = folderNames[folderNames.length - 1];
  //   //       SubFolders = folderNames[folderNames.length - 2];
  //   //       let currentItem: EpbtFaDynamicViewModel = {
  //   //         caption: item.name, id: MainFolder, parentId: SubFolders
  //   //       };
  //   //       nodes.push(currentItem);
  //   //     }
  //   //     else {
  //   //       if (folderNames.length == 1) {
  //   //         MainFolder = folderNames[0];
  //   //         SubFolders = [];
  //   //         let currentItem: EpbtFaDynamicViewModel = {
  //   //           caption: item.name, id: MainFolder, parentId: SubFolders
  //   //         };
  //   //         nodes.push(currentItem);
  //   //       }

  //   //     }

  //   //   });
  //   //   console.log(nodes, "nodes")
  //   // }
  //   // console.log("menus", menus);
  //   // return menus;
  // }

  folderDataClick(selectedFolder: any) {
    console.log(selectedFolder);
    this.SmartviewsService.selectedFolderItem = selectedFolder;
    const SubFolders = this.folderdata.filter(x => x.groupName.includes(selectedFolder.groupName + '\\'));
    this.router.navigate(['/home/smartviews/list']);
  }

}
